(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function() {
  // Mobile swipe fix with loop
  if (window.innerWidth <= 980) {
    var initDone = false;
    var init = function() {
      if (initDone) return;
      var $s = $('.js-product-slider.slick-initialized');
      if (!$s.length) return;
      initDone = true;

      // Build array of valid slide indices (non-featured)
      var validIndices = [];
      $('.media-gallery__wrapper').each(function(i) {
        if (!$(this).hasClass('featured-slide')) {
          validIndices.push(i);
        }
      });
      var lastValidIndex = validIndices[validIndices.length - 1];
      var firstValidIndex = validIndices[0];

      // Check if Customily canvas is active
      var isCustomilyActive = function() {
        var canvas = document.querySelector('.cl-canvas-container');
        return canvas && canvas.offsetHeight > 100;
      };

      // Disable default swipe
      $s.slick('slickSetOption', 'swipe', false, true);

      // Manual swipe detection
      var touchStartX = 0;
      var touchStartY = 0;
      var slider = $s[0];

      slider.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      slider.addEventListener('touchend', function(e) {
        // If Customily is active, let it handle touches
        if (isCustomilyActive()) {
          // Re-enable swipe temporarily for Customily
          return;
        }

        var touchEndX = e.changedTouches[0].clientX;
        var touchEndY = e.changedTouches[0].clientY;
        var diffX = touchStartX - touchEndX;
        var diffY = touchStartY - touchEndY;

        // Only handle horizontal swipes
        if (Math.abs(diffX) > 50 && Math.abs(diffX) > Math.abs(diffY)) {
          var currentSlide = $s.slick('slickCurrentSlide');

          if (diffX > 0) {
            // Swipe left - next
            if (currentSlide >= lastValidIndex) {
              $s.slick('slickGoTo', firstValidIndex, false);
            } else {
              for (var i = 0; i < validIndices.length; i++) {
                if (validIndices[i] > currentSlide) {
                  $s.slick('slickGoTo', validIndices[i], false);
                  break;
                }
              }
            }
          } else {
            // Swipe right - prev
            if (currentSlide <= firstValidIndex) {
              $s.slick('slickGoTo', lastValidIndex, false);
            } else {
              for (var i = validIndices.length - 1; i >= 0; i--) {
                if (validIndices[i] < currentSlide) {
                  $s.slick('slickGoTo', validIndices[i], false);
                  break;
                }
              }
            }
          }
        }
      }, { passive: true });
    };
    setTimeout(init, 500);
    setTimeout(init, 2000);
  }

  // Fix Safari tablet: force height auto on cl-sticky-container
  if (window.innerWidth >= 768 && window.innerWidth <= 979) {
    var fixStickyContainer = function() {
      var stickyContainer = document.querySelector('.cl-sticky-container');
      if (stickyContainer) {
        stickyContainer.style.height = 'auto';
      }
    };
    setTimeout(fixStickyContainer, 500);
    setTimeout(fixStickyContainer, 1000);
    setTimeout(fixStickyContainer, 2000);
    setInterval(fixStickyContainer, 1000);
  }

  // Customily close button (mobile only)
  window.innerWidth <= 980 && (function() {
    var c, b, o, moved = false;
    var check = function() {
      c = document.querySelector('.cl-canvas-container');
      b = document.querySelector('.customily-close-btn');
      if (c && b) {
        b.style.display = c.offsetWidth && c.offsetHeight ? 'block' : 'none';
        // Move button inside cl-canvas-container so it moves with the canvas
        if (!moved && !c.contains(b)) {
          c.appendChild(b);
          moved = true;
        }
      }
    };
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('customily-close-btn')) {
        // Hide Customily canvas
        window.dispatchEvent(new Event('customily-live-preview-hide-canvas'));

        // Reset z-index so it doesn't cover the header
        var canvasContainer = document.querySelector('.cl-canvas-container');
        if (canvasContainer) {
          canvasContainer.style.zIndex = '1';
        }
        var productMedia = document.querySelector('.product-single__media');
        if (productMedia) {
          productMedia.style.zIndex = '1';
        }

        // Go to first slide using slick
        var $slider = $('.js-product-slider.slick-initialized');
        if ($slider.length) {
          $slider.slick('slickGoTo', 0);
        }
      }
    });
    setTimeout(function() { setInterval(check, 500); }, 1000);
  })();
})();
  } catch(e) { console.error(e); }
})();

})();
